import { ChangeDetectionStrategy,  Component, Inject, input } from "@angular/core";

import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'soft-ktostamm-lieferant-field-ok-data-view',
    imports: [],
    templateUrl: './ktostamm-lieferant.list-view.html',
    styleUrls: ['./ktostamm-lieferant.list-view.css']
})
export class KtostammLieferantListView implements FieldOkItemComponent<any>{

  readonly item = input<any>();

  constructor() {
  }
}
